'use client';

import type { ReactNode } from 'react';

// gloss
export type RuleSurfacePaneProps<T> = {
  surface: T | null | undefined;
  isLoading: boolean;
  isError: boolean;
  errorMessage?: string;
  loadingMessage?: string;
  render: (surface: T) => ReactNode;
};

// gloss
export const RuleSurfacePane = <T,>({
  surface,
  isLoading,
  isError,
  errorMessage,
  loadingMessage,
  render,
}: RuleSurfacePaneProps<T>) => {
  if (isError) {
    return (
      <p className="text-destructive text-sm">{errorMessage ?? 'Couldn’t load the condition surface. Try again.'}</p>
    );
  }
  if (isLoading || surface == null) {
    return <p className="text-muted-foreground text-sm">{loadingMessage ?? 'Loading the condition surface…'}</p>;
  }
  return <>{render(surface)}</>;
};
